import React, { Component } from "react";
import { connect } from "react-redux";
import Modal from "../common/Modal";
import { changePassword } from "../../store/auth/authActions";
import { changePasswordValidationadmin } from "../../validation/validation";
import { clearErrors } from "../../store/errors/errorAction";
import isEmpty from "../../validation/is-empty";

export class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      current_password: "",
      password: "",
      confirm_password: "",
      errors: {},
    };
  }

  componentWillUnmount() {
    this.props.clearErrors();
  }

  static getDerivedStateFromProps(props, state) {
    if (!isEmpty(props.errors.error)) {
      return {
        errors: { common: props.errors.error },
      };
    } else {
      if (state.errors.common) {
        delete state.errors.common;
      }
    }
    return null;
  }
  handleCancelChangePassword = () => {
    this.props.handleCancelChangePassword();
    this.props.clearErrors();
  };
  handleSubmit = (e) => {
    e.preventDefault();
    const { user } = this.props.auth;
    const { current_password, password, confirm_password } = this.state;
    const addData = {
      current_password,
      password,
      confirm_password,
    };
    const { errors, isValid } = changePasswordValidationadmin(addData);

    if (isValid) {
      this.props.clearErrors();
      this.props.changePassword(addData, user.id);
      this.setState({
        current_password: "",
        password: "",
        confirm_password: "",
      });

      this.props.handleCancelChangePassword();
    } else {
      this.setState({ errors });
    }
  };
  handleChange = (e) => {
    const errors = this.state.errors;
    if (errors[e.target.name]) {
      delete errors[e.target.name];
      delete errors.common;
    }
    this.props.clearErrors();
    this.setState({ [e.target.name]: e.target.value, errors });
  };

  render() {
    const { password, confirm_password, current_password, errors } = this.state;
    return (
      <Modal
        id="changePassword"
        key="changePassword"
        open={true}
        size={"small-list"}
        header="Change Password"
        onClose={this.handleCancelChangePassword}
      >
        <div className="row">
          <div className="col-md-12">
            <form onSubmit={this.handleSubmit}>
              <div className="box-body">
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1">Password</label>
                  <input
                    type="password"
                    className="form-control"
                    autoComplete="off"
                    id="password"
                    name="current_password"
                    placeholder="Password"
                    value={current_password}
                    onChange={this.handleChange}
                    //required
                  />
                  {errors.current_password ? (
                    <span style={{ color: "red" }}>
                      {errors.current_password}
                    </span>
                  ) : null}
                </div>
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1">New Password</label>
                  <input
                    type="password"
                    className="form-control"
                    id="password"
                    name="password"
                    autoComplete="off"
                    placeholder="New Password"
                    value={password}
                    onChange={this.handleChange}
                    //required
                  />
                  {errors.password ? (
                    <span style={{ color: "red" }}>{errors.password}</span>
                  ) : null}
                </div>
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1">Confirm Password</label>
                  <input
                    type="password"
                    className="form-control"
                    autoComplete="off"
                    id="confirm_password"
                    name="confirm_password"
                    placeholder="Confirm Password"
                    value={confirm_password}
                    onChange={this.handleChange}
                    //required
                  />
                  {errors.confirm_password ? (
                    <span style={{ color: "red" }}>
                      {errors.confirm_password}
                    </span>
                  ) : null}
                </div>
              </div>
              {errors.common ? (
                <span style={{ color: "red" }}>{errors.common}</span>
              ) : null}
              <div className="box-footer" style={{ textAlign: "center" }}>
                <button type="submit" className="btn btn-primary">
                  Update
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
});

export default connect(mapStateToProps, { changePassword, clearErrors })(
  ChangePassword
);
